import { AsyncPipe } from "@angular/common";
import { Component, inject, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { Observable } from "rxjs";
import { ConnectionStatus, EventHubService } from "~app/common/services/eventhub.service";
import { IconComponent } from "../../icon/icon.component";

@Component({
    selector: "rask-eventhub-status",
    templateUrl: "./eventhub-status.component.html",
    styleUrl: "./eventhub-status.component.scss",
    changeDetection: ChangeDetectionStrategy.Eager,
    imports:[
        IconComponent,
        AsyncPipe
    ]
})
export class EventhubStatusComponent implements OnInit {
    protected eventhubConnectionStatus$: Observable<ConnectionStatus>;
    private readonly eventhubService = inject(EventHubService);

    ngOnInit(): void {
        this.eventhubConnectionStatus$ = this.eventhubService.connectionStatus$;
    }
}
